
import React, { useEffect } from 'react';
import '../Assets/Css/about.css';
import { Container, Row, Col, Button } from 'react-bootstrap';
import AOS from 'aos';
import 'aos/dist/aos.css';
import { Helmet } from 'react-helmet';
import aboutdiversity from '../Assets/Images/mobiusunity.avif'
import diversity2 from '../Assets/Images/aboutimge1.avif'
import mobiusabout1 from '../Assets/Images/aboutmobiusunity1.jpg'
import mobiusabout2 from '../Assets/Images/aboutmobiusunity2.jpg'
import { IoArrowForwardCircleOutline } from "react-icons/io5";

// testimonials
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, Pagination, Navigation } from 'swiper/modules';
import { FaStar } from 'react-icons/fa';
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';

export default function AboutUs() {
  useEffect(() => {
    AOS.init({ duration: 1000 });
  }, []);

 const testimonials = [
  "Mobius Unity isn’t just a consulting firm — they’re purpose-driven partners who believe in uplifting communities. Their dedication to regenerative solutions is unmatched.",
  "Working with Mobius Unity gave our project clarity, structure, and purpose. Their team approaches every challenge with heart, intelligence, and a commitment to real change.",
  "Their ability to merge data-driven strategy with human-centered values is what makes Mobius Unity stand out. We felt heard, empowered, and supported every step of the way.",
  "Mobius Unity’s leadership team embodies the vision they promote. Their passion for environmental, social, and economic justice radiates through every engagement.",
  "From the very first call, it was clear that Mobius Unity cares deeply about impact. They listened first, then built solutions that aligned perfectly with our mission.",
];


  return (
    <>

<Helmet>
      {/* Page Title */}
      <title>About Mobius Unity Consulting | Empowering Innovation Through Unity & Purpose</title>

      {/* Meta Description */}
      <meta
        name="description"
        content="Learn about Mobius Unity Consulting – our story, our mission, and the leaders behind the movement. We empower communities through innovation, circular economies, and regenerative business models."
      />

      {/* Keywords */}
      <meta
        name="keywords"
        content="Mobius Unity Consulting, about us, who is Mobius, consulting for sustainability, community empowerment, regenerative business, circular economy, eco consulting, food security, soil remediation, David D, John B"
      />

      {/* Author */}
      <meta name="author" content="Mobius Unity Consulting" />

      {/* Canonical URL */}
      <link rel="canonical" href="https://mobiusunityconsulting.com/about" />

      {/* Open Graph / Facebook */}
      <meta property="og:title" content="About Mobius Unity Consulting" />
      <meta
        property="og:description"
        content="Mobius Unity Consulting is more than a firm — it's a movement led by experienced innovators who co-create regenerative, community-focused solutions. Meet the team driving impact."
      />
      <meta property="og:type" content="website" />
      <meta property="og:url" content="https://mobiusunityconsulting.com/about" />
      <meta property="og:image" content="https://mobiusunityconsulting.com/assets/about-og-image.jpg" />

      {/* Twitter Card */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content="About Mobius Unity Consulting" />
      <meta
        name="twitter:description"
        content="Learn about the mission, values, and leadership of Mobius Unity Consulting — creating sustainable solutions for communities, businesses, and the environment."
      />
      <meta name="twitter:image" content="https://mobiusunityconsulting.com/assets/about-twitter-image.jpg" />
      <meta name="twitter:site" content="@MobiusUnity" />
    </Helmet>

      {/* Banner Section */}
      <div className="banner2-section d-flex align-items-center justify-content-center">
        <div className="banner2-overlay text-center" data-aos="zoom-in">
          <h2 className="banner1-title">We Are Mobius! We are One!</h2>
          <p className="banner1-subtitle" data-aos="zoom-in" data-aos-delay="200">
            Empowering innovation through unity, technology, and purpose.
          </p>

        </div>
      </div>

      {/* About Us Section */}
      <section className="py-5 mb-4" id="about">
        <Container>
          <Row className="align-items-center">
            <Col md={7} data-aos="zoom-in">
              <Row className="text-center section-heading" data-aos="zoom-in" data-aos-delay="200">
                <Col>
                  <h3 className="fw-bold section-title">
                    What is a <span style={{ color: '#04A1D3' }}> “Mobius”?</span>
                    <span className="title-decoration"> </span>
                  </h3>
                  <p className="text-muted mx-auto" style={{ maxWidth: 700 }}>
                    “Mobius” represents unity, endless possibilities, and a continuous journey of innovation.
                  </p>
                </Col>
              </Row>

              <p>
                The <strong>Mobius</strong>  strip is a shape with just one side and one edge, symbolizing unity and infinity. It reminds us that sometimes the path to progress requires us to think outside the box and view things from a different perspective.
              </p>
            </Col>

            <Col md={5} data-aos="zoom-in" className="d-flex justify-content-center align-items-center ">
              <img src={aboutdiversity} alt="About Vinora" className="aboutimg  " />
            </Col>
          </Row>
        </Container>
      </section>

      <section className="py-5   vinora-background">
        <Container>

          <Row className="p-4">
            <Col md={6} className="text-center">
              <img
                src={diversity2}
                alt="diversity2"
                className="nskchoco  mb-4"
                data-aos="zoom-in" data-aos-delay="200"


              />
            </Col>
            <Col md={6} data-aos="zoom-in" >
              <h3 className="fw-bold  section-title mb-4">
              <span style={{ color: 'white' }}>  How do “Mobius” and  Consulting go together?</span>
                <span className="title-decoration"> </span>
              </h3>
              <p style={{color:'white',fontSize:'16px',lineHeight:'1.8'}} >
                Consulting is like a journey of discovery and exploration. We work collaboratively with our clients to find new solutions and achieve their goals. Our approach is empowering and collaborative, building lasting relationships to achieve great things together.
              </p>
               <Button variant="light" className="banner1-button border " href='/services'
                data-aos="zoom-in" data-aos-delay="300">
                Explore Services <IoArrowForwardCircleOutline size={30} style={{ animation: 'pulse 1.5s infinite', transformOrigin: 'center' }} />
              </Button>
            </Col>
          </Row>


          
        </Container>
      </section>

      <section className="mobius-section  py-5" style={{ backgroundColor: '#F8FBFF' }}>
        <Container className='p-4'> 
          <Row className="text-center mb-5" data-aos="fade-down">
            <Col>
              <h3 className="fw-bold section-title">
                What is Mobius Unity <span style={{ color: '#04A1D3' }}>Consulting about?</span>
                <span className="title-decoration">  </span>
              </h3>
            </Col>
          </Row>
          <Row className="align-items-center mb-5">
            <Col md={6} data-aos="zoom-in" data-aos-delay="200">
              <p style={{textAlign:'justify'}}>
                At <strong>Mobius Unity Consulting,</strong> our mission is to strengthen communities and fortify farmer food supply chains. We do this by providing effective consulting services and introducing innovative business models and solutions that utilize waste to create multi-value products. Our “Business in a Box” approach to community development streamlines the process of building profitable, regenerative, and eco-sustainable businesses that can support critical supply chains.
              </p>
            </Col>
            <Col md={6} className="text-center" data-aos="zoom-in" data-aos-delay="300">
              <img
                src={mobiusabout1}
                alt="Community Empowerment"
                className="img-fluid rounded shadow"
                style={{ height: '230px',width:'350px', objectFit: 'cover' }}
              />
            </Col>
          </Row>

          {/* Row 2: Image Left, Text Right */}
          <Row className="align-items-center mb-5 flex-md-row-reverse">
            <Col md={6} data-aos="zoom-in" data-aos-delay="300">
              <p style={{textAlign:'justify'}}>
                We believe that by aggregating business opportunities, collective connections, and resources, we can create a unified impact that strengthens communities and fosters sustainable development. Our team of data scientists and analytics experts ensures that each project is approached with a specialized focus on improving food and community security, resulting in regenerative, profitable, and eco-sustainable businesses that contribute to the development of leadership campuses throughout America. At Mobius Unity Consulting, we’re committed to making a positive difference and helping our clients achieve their goals.
              </p>
            </Col>
            <Col md={6} className="text-center" data-aos="zoom-in" data-aos-delay="400">
              <img
                src={mobiusabout2}
                alt="Data Science and Strategy"
                className="img-fluid rounded shadow"
                style={{ maxHeight: '320px', objectFit: 'cover' }}
              />
            </Col>
          </Row>

        </Container>
      </section>



<section className="py-1" style={{ backgroundColor: '#F8FBFF' }}>
  <Container>
    {/* About Our Story */}
    <Row className="mb-5">
      <Col md={{ span: 10, offset: 1 }} className="text-center">
       <h3 className="fw-bold section-title" data-aos="fade-down" >
                  About our  <span style={{ color: '#04A1D3' }}>Story</span>
                <span className="title-decoration">  </span>
              </h3>
        
    
        <p className="text-muted" style={{textAlign:'justify',fontSize:'18px'}} data-aos="zoom-in" data-aos-delay="200">
          At <strong> Mobius Unity Consulting,</strong> our passion is to serve others and the world. Co-founders David and John have a shared vision of creating positive change through innovative consulting services. We specialize in circular economies, soil remediation, innovative technologies, entrepreneurship, job creation, and more. Our team of experts and innovators brings a wealth of knowledge, experience, and passion to every project we undertake. We bring environmental, economic, and social justice to every project by listening first and then providing solutions that empower our partners to achieve their goals. We believe that by working together, we can create a better world for everyone. At Mobius Unity Consulting, we are committed to supporting eco-champions and making a positive impact on the world.
        </p>
      </Col>
    </Row>

    {/* About Our Founders */}
    <Row className="mb-5" data-aos="fade-down" >
      <Col md={{ span: 10, offset: 1 }} className="text-center">
       <h3 className="fw-bold section-title">
                  About our  <span style={{ color: '#04A1D3' }}>Founders</span>
                <span className="title-decoration">  </span>
              </h3>
        
       
      </Col>
    </Row>

    {/* Founders Cards */}
    <Row className="g-4 justify-content-center mb-5">
      {/* David D. */}
      <Col md={6} data-aos="zoom-in" data-aos-delay="200">
        <div className="p-4 rounded shadow-sm h-100" style={{ backgroundColor: '#FFFFFF', borderBottom: '4px solid #04A1D3',borderRight: '4px solid #04A1D3' }}>
          <h5 className="fw-bold mb-1">David D.</h5>
          <h6 className="text-muted mb-3">Head Consultant / Manager</h6>
          <p className="text-muted">
            David is a dynamic and multi-lingual entrepreneur and inventor with over 45 years of management experience. He is results-oriented and has an outstanding track record of achieving aggressive bottom line numbers through leadership, training, engineering, strategic planning, process efficiencies, and workforce development. David’s consistent success in running businesses is a testament to his expertise and commitment to achieving measurable results.
          </p>
        </div>
      </Col>

      {/* John B. */}
      <Col md={6} data-aos="zoom-in" data-aos-delay="200">
        <div className="p-4 rounded shadow-sm h-100" style={{ backgroundColor: '#FFFFFF', borderBottom: '4px solid #04A1D3',borderRight: '4px solid #04A1D3' }}>
          <h5 className="fw-bold mb-1">John B.</h5>
          <h6 className="text-muted mb-3">Head Consultant / Manager</h6>
          <p className="text-muted">
            John is a seasoned strategist, innovative business developer, and global economist with a passion for leveraging his expertise to create positive change. He inherited his passion for business from his successful entrepreneur father and has a reputation as a technical sales and service leader, having worked with prestigious institutions and government agencies. John’s skills as an innovator and strategist enable him to weave gaps between businesses and position people for long-term success, creating shared opportunities for growth and success.
          </p>
        </div>
      </Col>
    </Row>
  </Container>
</section>





      <section className="testimonial-carousel-section my-5">
        <div className="container py-3 ">
          <Row className="align-items-center justify-content-center flex-md-row m-0">
            <h3 className="fw-bold text-center section-title" data-aos="fade-down" data-aos-delay="100">
              Empowering <span style={{ color: '#04A1D3' }}>Innovation</span>
              <span className="title-decoration mb-2"></span>
            </h3>
            <p className="text-muted text-center" style={{ maxWidth: 700 }} data-aos="fade-down" data-aos-delay="100">
              we deliver smart solutions that empower growth and innovation.
            </p>
            <Col xs={12} md={8} className="text-center order-1 order-md-2" data-aos="zoom-in" data-aos-delay="200">

              <Swiper
                modules={[Autoplay, Pagination, Navigation]}
                spaceBetween={30}
                loop={true}
                autoplay={{
                  delay: 5000,
                  disableOnInteraction: false,
                }}
                pagination={{ clickable: true }}
                navigation={true}
                className="testimonial-swiper"
              >
                {testimonials.map((text, idx) => (
                  <SwiperSlide key={idx}>
                    <div className="stars mb-1">
                      {[...Array(5)].map((_, i) => (
                        <FaStar key={i} color="#036839" />
                      ))}
                    </div>
                    <p className="testimonial-quote">
                      <span className="quote-mark">“</span>
                      {text}
                      <span className="quote-mark">”</span>
                    </p>
                    <p className="author-name">Anonymous</p>
                  </SwiperSlide>
                ))}
              </Swiper>
            </Col>
          </Row>
        </div>
      </section>


    </>
  );
}
